import { configureStore } from "@reduxjs/toolkit";
import authReducer from './slices/authSlice.js';
import adminAuthReducer from './slices/adminAuthSlice.js';
import { apiSlice } from "./slices/apiSlice.js";

const store = configureStore({
    reducer: {
      auth: authReducer,
      adminAuth: adminAuthReducer,
      // Dynamically inject apiSlice reducer using apiSlice.reducerPath
      [apiSlice.reducerPath]: apiSlice.reducer,
    },
    // Add RTK Query middleware to handle caching, invalidation, polling, etc.
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware), 
    devTools: process.env.NODE_ENV !== 'production', // Enable DevTools only in development
});


export default store;